import Alpine from "alpinejs";
import persist from "./persist";

Alpine.plugin(persist);

export { Alpine };
